module.exports = __webpack_public_path__ + "static/media/header-img-2.25386b53.jpg";